import { createSlice } from "@reduxjs/toolkit";

const alertSlice = createSlice({
  name: "alert",
  initialState: {
    alertState: false,
    type: null,
  },
  reducers: {
    setAlert: (state, action) => {
      state.alertState = true;
      state.type = action.payload;
    },
    resetAlert: (state, action) => {
      state.alertState = false;
      state.type = null;
    },
  },
});

export const { setAlert, resetAlert } = alertSlice.actions;
export default alertSlice.reducer;
